/**
 * Application configuration
 * Single source of truth for feature flags and settings.
 */

// API
export const API_URL =
	process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:4001";

// Feature flags
export const BILLING_ENABLED =
	process.env.NEXT_PUBLIC_BILLING_ENABLED !== "false";

// Signup kill switch (abuse response) - flip alongside the API's
// SIGNUP_DISABLED env var. Hides signup CTAs instead of showing a form
// that errors on submit.
export const SIGNUP_DISABLED =
	process.env.NEXT_PUBLIC_SIGNUP_DISABLED === "true";

// Fivebar product analytics - the snippet renders only when both are set
export const FIVEBAR_HOST = process.env.NEXT_PUBLIC_FIVEBAR_HOST?.replace(
	/\/+$/,
	"",
);
export const FIVEBAR_PROJECT_KEY = process.env.NEXT_PUBLIC_FIVEBAR_PROJECT_KEY;

// Contact
export const SUPPORT_EMAIL = "info@sendpigeon.dev";
